import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Users, Fuel, Check } from "lucide-react";
import { imgUrl } from "../lib/img";

export const CarCard = ({ car, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.08 }}
      data-testid={`car-card-${car.slug}`}
    >
      <Link to={`/fleet/${car.slug}`} className="group block border border-white/10 bg-[#0F0F0F] overflow-hidden">
        <div className="relative aspect-[16/10] overflow-hidden bg-black">
          <img
            src={imgUrl(car.image)}
            alt={car.name}
            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
          />
          <span className="absolute top-4 left-4 border border-white/20 bg-black/70 text-white text-[10px] uppercase tracking-wider px-3 py-1">
            {car.type}
          </span>
          <span className="absolute top-4 right-4 bg-[#D4AF37] text-black text-[10px] font-medium uppercase tracking-wider px-3 py-1 flex items-center gap-1">
            <Fuel size={11} /> {car.mpg} MPG
          </span>
        </div>
        <div className="p-6">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-white/40 text-xs uppercase tracking-wider">{car.brand}</p>
              <h3 className="font-serif text-2xl mt-1 leading-none">{car.name}</h3>
            </div>
            <div className="text-right">
              <p className="text-[#D4AF37] text-xl font-light">${car.price_per_week}</p>
              <p className="text-white/40 text-xs">/ week</p>
            </div>
          </div>

          <div className="flex flex-wrap gap-1.5 mt-4">
            {car.rideshare?.map((p) => (
              <span key={p} className="flex items-center gap-1 text-[10px] uppercase tracking-wide text-white/60 border border-white/15 px-2 py-1">
                <Check size={10} className="text-[#D4AF37]" /> {p}
              </span>
            ))}
          </div>

          <div className="flex items-center gap-6 mt-5 pt-5 border-t border-white/10 text-white/50 text-sm">
            <span className="flex items-center gap-2"><Users size={15} /> {car.seats} seats</span>
            <span className="text-white/40">${car.price_per_day}/day</span>
            <span className="ml-auto text-white/70 group-hover:text-[#D4AF37] transition-colors">View →</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
